module.exports = __webpack_public_path__ + "img/yishi26.78068782.jpg";